import { render, staticRenderFns } from "./Difference.vue?vue&type=template&id=a23f7be6&scoped=true&"
import script from "./Difference.vue?vue&type=script&lang=js&"
export * from "./Difference.vue?vue&type=script&lang=js&"
import style0 from "./Difference.vue?vue&type=style&index=0&id=a23f7be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23f7be6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
